import { render, staticRenderFns } from "./ResultPortal.vue?vue&type=template&id=1c39dc6f&scoped=true"
import script from "./ResultPortal.vue?vue&type=script&lang=js"
export * from "./ResultPortal.vue?vue&type=script&lang=js"
import style0 from "./ResultPortal.vue?vue&type=style&index=0&id=1c39dc6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39dc6f",
  null
  
)

export default component.exports